import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { List } from 'immutable';
import { LoadingPane, Table, accessibilityNotificationsEmitter } from '../../common';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as modifyIntakeActions from './modify-intake-form.actions';
import * as intakeFormConstants from './intake-form-constants';
import { IntakeFormValidation, validationConstants } from '../validate-intake-form';
import './modify-demographics.scss';
import EditQuestionModal from '../../intake/edit-question-modal';

export class ModifyDemographicsComponent extends Component {

  handleEditQuestionCancel() {
    const { modifyIntakeActions } = this.props;
    const { closeDemoQuestionEditModal } = modifyIntakeActions || {};
    closeDemoQuestionEditModal();
  }

  componentDidMount() {
    const { modifyIntakeActions } = this.props;
    const { updatePreviewTabRedirect } = modifyIntakeActions || {};

    updatePreviewTabRedirect('/demographics');
  }

  componentDidUpdate(prevProps, prevState) {
    const { modifyIntakeActions, modifyIntake } = this.props;
    const { editQuestion } = modifyIntake;
    const { updatePreviewTabRedirect } = modifyIntakeActions || {};
    const { showQuestionEditModal } = editQuestion || {};

    const { modifyIntake: prevModifyIntake  } = prevProps;
    const { editQuestion: prevEditQuestion } = prevModifyIntake || {};
    const { showQuestionEditModal: prevShowQuestionEditModal } = prevEditQuestion;

    if(showQuestionEditModal && !prevShowQuestionEditModal) {
      var modalFocusTarget = document.getElementById('questionModalContent');
      if(modalFocusTarget) modalFocusTarget.focus();
    }
    else if(!showQuestionEditModal && prevShowQuestionEditModal) {
      var viewFocusTarget = document.getElementById('view');
      if(viewFocusTarget) viewFocusTarget.focus();
    }

    updatePreviewTabRedirect('/demographics');
  }

  handleKeyboardInput(e, demographicId, demographicLabel, moveUp) {
    if(e.keyCode === 13 || e.keyCode === 32) {
      this.handleUpdateOrder(demographicId, demographicLabel, moveUp);
    }
  }

  handleUpdateOrder(uniqueId, demographicLabel, moveUp) {
    const { updateOrder } = this.props;
    updateOrder(intakeFormConstants.demographicsSection, intakeFormConstants.demographicId, uniqueId, moveUp);


    const confirmText = moveUp ? demographicLabel + " has moved up" : demographicLabel + " has moved down";
    accessibilityNotificationsEmitter.assertive(confirmText);
  }

  handleUpdateIncluded(demographicId, sectionValue) {
    this.handleUpdateQuestion(demographicId, intakeFormConstants.included, sectionValue);
    if(!sectionValue) {
      this.handleUpdateQuestion(demographicId, intakeFormConstants.required, sectionValue);
    }
  }

  handleUpdateCustomLabel(label) {
    const { modifyIntakeActions } = this.props;
    const { updateCustomLabel } = modifyIntakeActions;
    updateCustomLabel(label);
  }

  handleUpdateCustomTooltip(tooltip) {
    const { modifyIntakeActions } = this.props;
    const { updateCustomTooltip } = modifyIntakeActions;
    updateCustomTooltip(tooltip);
  }

  applyQuestionOptions() {
    const { modifyIntake, modifyIntakeActions } = this.props;
    const { editQuestion } = modifyIntake;
    const { questionEditModalQuestionId: demographicId, label, tooltip } = editQuestion || {};

    this.handleUpdateQuestion(demographicId, intakeFormConstants.label, label);
    this.handleUpdateQuestion(demographicId, intakeFormConstants.tooltip, tooltip);
    modifyIntakeActions.closeDemoQuestionEditModal();

  }

  handleUpdateQuestion(demographicId, section, sectionValue) {
    const { updateValue, value } = this.props;
    var questions = value && value.get(intakeFormConstants.demographicsSection);
    var index = 0;
    if(!!questions) {
      var existingIndex = questions.findIndex(val => val.get(intakeFormConstants.demographicId) === demographicId);
      if(existingIndex === -1) {
        index = questions.size;
      }
      else {
        index = existingIndex;
      }
    }

    updateValue([intakeFormConstants.demographicsSection, index, section], sectionValue, true);
  }

  handleEditClick(demographicId) {
    const { modifyIntakeActions, match, formMode } = this.props;
    const { showDemoQuestionEditModalEditIntake, showDemoQuestionEditModalCreateIntake } = modifyIntakeActions || {};
    const { params } = match || {};
    const { id: intakeFormId } = params || {};

    const questionModalText = "Enter custom label and tooltip for demographic.";
    accessibilityNotificationsEmitter.assertive(questionModalText);

    if(formMode === intakeFormConstants.editStatus.createNew) {
      showDemoQuestionEditModalCreateIntake(demographicId);
    }
    else if(formMode === intakeFormConstants.editStatus.editExisting) {
      showDemoQuestionEditModalEditIntake(demographicId, intakeFormId);
    }
  }

  getDemographicQuestions() {
    const { value } = this.props;
    var questions = value && value.get(intakeFormConstants.demographicsSection);
    return !!questions ? questions.sort((a, b) =>
      a.get(intakeFormConstants.order) - b.get(intakeFormConstants.order)) : List([]);
  }

  renderQuestion(demographicsForm, question, showUpArrow, showDownArrow) {
    const { disabled } = this.props;
    const demographicId = question && question.get(intakeFormConstants.demographicId);
    const dataType = question && question.get('dataType');
    const isIncluded = question && question.get(intakeFormConstants.included);
    const isRequired = question && question.get(intakeFormConstants.required);
    const element = demographicsForm && demographicsForm.elements &&
      demographicsForm.elements.find(val => val.id === demographicId);
    if(!element) {
      return <tr key={demographicId}/>
    }

    // this is a list of the demographic element types that should not be editable
    const demographicHiddenTypes = [
      'heading'//  Section Header
    ]

    const editLabel = demographicHiddenTypes.includes(element.type) || element.type === undefined || element.type === null ? null :
      <span className="edit-label">
        <a onClick={e => this.handleEditClick(demographicId)} tabIndex={0}>Edit</a>
      </span>

    return (
      <tr key={demographicId}>
        <td>
          <div className={showUpArrow ? '' : 'hidden'}>
            <span
              tabIndex={0}
              role="button"
              className="glyphicon glyphicon-chevron-up"
              title='Move Up'
              aria-label='Move Up'
              onClick={e => this.handleUpdateOrder(demographicId, element.label, true)}
              onKeyDown={e => this.handleKeyboardInput(e, demographicId, element.label, true)} />
          </div>
          <div className={showDownArrow ? '' : 'hidden'}>
            <span
              tabIndex={0}
              role="button"
              className="glyphicon glyphicon-chevron-down"
              title='Move Down'
              aria-label='Move Down'
              onClick={e => this.handleUpdateOrder(demographicId, element.label, false)}
              onKeyDown={e => this.handleKeyboardInput(e, demographicId, element.label, false)}/>
          </div>
        </td>
        <td className='table-text-content'>
          <div>
            <span className="question-label">{element.label}</span>
            {editLabel}
          </div>
        </td>
        <td className='table-text-content'>{dataType}</td>
        <td>
          <input
            id={demographicId + "-isIncluded"}
            type="checkbox"
            checked={isIncluded}
            disabled={element.isRequired || disabled}
            onChange={e => this.handleUpdateIncluded(demographicId, e.target.checked)}
            aria-label={"include"} />
        </td>
        <td>
          <input
            id={demographicId + "-isRequired"}
            type="checkbox"
            checked={isRequired}
            disabled={!isIncluded || element.isRequired || disabled}
            onChange={e => this.handleUpdateQuestion(demographicId, intakeFormConstants.required, e.target.checked)}
            aria-label={"required"} />
        </td>
      </tr>
    );
  }

  render() {
    const { modifyIntake, siteId, programId, intakeValidationResult, validationMessage, loadingValidation } = this.props;
    const { programDemographics : allProgramsDemographics, editQuestion } = modifyIntake || {};
    const { showQuestionEditModal, questionEditModalQuestionId, label: editCustomLabel, tooltip: editCustomTooltip } = editQuestion || {};

    const programDemographicsState = allProgramsDemographics && allProgramsDemographics.getIn([siteId, programId]);
    const { isFetching : demographicsLoading, err : demographicsErr, data : programDemographics } = programDemographicsState || {};

    //get the question values
    const values = this.getDemographicQuestions();

    //get the demographic name, type and other ETO information
     const element = programDemographics && programDemographics.elements &&
       programDemographics.elements.find(val => val.id === questionEditModalQuestionId);


    const header = (
      <tr>
        <th>ORDER</th>
        <th>DEMOGRAPHIC</th>
        <th>DATA TYPE</th>
        <th>INCLUDE</th>
        <th>REQUIRED</th>
      </tr>
    );

    const modal =
      <EditQuestionModal
        modalId="questionModalId"
        contentId="questionModalContent"
        show={showQuestionEditModal}
        onCancel={() => this.handleEditQuestionCancel()}
        onSave={(label, tooltip) => this.applyQuestionOptions(questionEditModalQuestionId, label, tooltip)}
        onLabelChange={(label) => this.handleUpdateCustomLabel(label)}
        onTooltipChange={(tooltip) => this.handleUpdateCustomTooltip(tooltip)}
        title={element && element.label}
        subtitle={element && element.type}
        label={editCustomLabel}
        tooltip={editCustomTooltip} />
    return (
      <div id="modify-demographics">
        <IntakeFormValidation
          validationResult={intakeValidationResult}
          excludedSections={[
            validationConstants.aboutSection,
            validationConstants.touchpointSection,
            validationConstants.loadingSection,
          ]}
          titleMessage={validationMessage}
          hideSectionHeaders={true}
          isLoading={loadingValidation}/>
        <p>Users who complete and submit this form will be enrolled in the selected Program.</p>
        <p>Here, select the Site / Program Demographics you want to include on the intake form. First and Last Name are required.</p>
        <br/>

        <form className="form-horizontal">
          <LoadingPane
            isLoading={demographicsLoading}
            err={demographicsErr}>
            <Table
              isLoading={demographicsLoading}
              header={header}
              items={values.toArray()}
              mapItem={(val, index) => this.renderQuestion(programDemographics, val, index !== 0, index !== values.size - 1)}
              emptyMessage="This program has no demographic questions available"
              loadingMessage="Loading demographics questions..."/>
          </LoadingPane>
        </form>
        {modal}
      </div>
    );
  }
}

ModifyDemographicsComponent.propTypes = {
  siteId: PropTypes.string,
  programId: PropTypes.string,
  modifyIntakeActions : PropTypes.object,
  modifyIntake : PropTypes.any,
  value : PropTypes.object,
  defaultValue : PropTypes.object,

  intakeValidationResult : PropTypes.object,
  validationMessage : PropTypes.string,
  loadingValidation : PropTypes.bool,
  validationErr : PropTypes.object,

  updateValue : PropTypes.func,
  updateOrder: PropTypes.func,
  disabled : PropTypes.bool,
  errors: PropTypes.array,
  showErrors: PropTypes.bool,
  formMode: PropTypes.oneOf(intakeFormConstants.editStatus),
};

const mapStateToProps = ({ modifyIntake }) => {
  return {
    modifyIntake,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    modifyIntakeActions: bindActionCreators(modifyIntakeActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps) (ModifyDemographicsComponent);
